homeHandler = {
    fullpageController: null,
    $fullpageContainer = $('.fullpage-container'),
    $navContainer = $('.nav-container'),
    
    scrollTo = function($hash, scrollSpeed = 1500){
        if ($hash !=  '#') {
            if ($($hash).length > 0) {
                var hashTop = $($hash).offset().top;
                var scrollTop = $('html, body').scrollTop();
                var headerHeight = $('header').outerHeight();

                if (scrollTop != hashTop) {
                    $('html, body').animate({
                        scrollTop: hashTop + 20 - headerHeight
                    }, scrollSpeed);
                }
            }
        }
    },
    
    init = function(){
        var self = this;
    
        $('.fullpage-container .section').each(function() {
            var headerHeight = $('header').outerHeight();
            $sectionInner = $(this).find('.section-inner');

            if ($sectionInner.hasClass('hero-section')) {
                var topPadding = parseInt($sectionInner.css('padding-top'));
                var newPadTop = headerHeight + topPadding;
                $sectionInner.css('padding-top', newPadTop+'px');
                $sectionInner.removeClass('hide');
            } 
        });

        $('body').on("click", "a", function(e) {
            var url = $(this).attr("href");
            if (url && url.includes('#')) {
                url = url.replace('/', '');       
                if ($(url).length !== 0) {
                    e.preventDefault();
                    var $reveal = $('body').find('.reveal');

                    if ($reveal) {
                        $reveal.foundation('close');
                    } 

                    self.scrollTo(url);             
                }               
            }
        });

        $(window).on('hashchange', function(e){
            if (window.location.hash) {
                self.scrollTo(window.location.hash);
            }
        });

        animateHandler.animateBackground();
               
    }
}